import React, { Component } from 'react';
import Responsive from 'react-responsive-decorator';
import {Col, Row} from 'react-bootstrap';
import Header from './header';
import MainMenu from './menu';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import { Redirect } from 'react-router';
import {connect} from 'react-redux';
import {
      hideDownloadList
    } from '../pages/recon/recon.actions';

import {
          clearCommonData
        } from '../common-redux/common.actions';



import Auth from '../auth/auth';
import ExpiryBanner from '../components/access/expiry-banner';
import {CONTEXT_ENABLED} from '../config/features';


const auth = new Auth();
const { getContext,getRoleId } = auth;

// #628: session monitoring moved OUT of this layout into <SessionGuard> (wired in
// main.js), which wraps every authenticated route so no layout can skip it.
class SecuredLayout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
      this.props.media({ minWidth: 768 }, () => {
        this.setState({
          isMobile: false
        });
      });

      this.props.media({ maxWidth: 768 }, () => {
        this.setState({
          isMobile: true
        });
      });
    }

    componentWillUnmount(){
      this.props.clearCommonData();
    }

  render() {

    //console.log("getContext()123",getContext());

    const currentPath = window.location.pathname;
    const isUserProfileAdmin = currentPath.startsWith('/user-profile-admin');

    // Surfaces that administer WHO MAY DO WHAT, rather than data. They need no context, so the
    // gates below must not bounce them — a super user with no context is the normal state for a
    // platform administrator, not an error.
    //
    // Slice 4b shipped /settings/access without this and it was unreachable by anyone: the tile is
    // gated on getIsSuperUser(), while the roleId===1 branch below redirected exactly those users
    // to /admin before the page could mount. On skokie_dev the only super user has no context and
    // the two context-holders are not super users, so the intersection was empty.
    //
    // Extends the existing /user-profile-admin exemption rather than moving the page under
    // AdminLayout, which hard-codes getRoleId() === 1 and would lock out the data_owner that
    // decision Q5 gives scoped access:grant to in slice 4c.
    const isAccessAdmin = currentPath.startsWith('/settings/access');
    const isContextFreeAdmin = isUserProfileAdmin || isAccessAdmin;

    if(CONTEXT_ENABLED && !isContextFreeAdmin && getContext() === null && getRoleId() !==1){
      // #622: context disabled → don't gate non-admins on /context; render normally.
      return(
        <Redirect to="/context" />
      )
    } else if(!isContextFreeAdmin && getContext() === null && getRoleId() ===1){
      return(
        <Redirect to="/admin" />
      )
    }
    else {
      let downloadFilesList=this.props.downloadingList.map(filename => <Chip key={filename} className="animate-flicker" label={"Downloading..."+filename+".xlsx"} />);

      return (
        <div>
          <Header />
          <MainMenu isMobile={this.state.isMobile} />
          {/* Placement A — app-wide, under the top bar. Renders null for everyone whose
              transitional authority is not inside the 14-day window, which today is every user
              on every deployment where the ac_* backfill has not run. */}
          <ExpiryBanner />
          <section className="app-main-container">
            {this.props.children}
          </section>
          <Row className={this.props.isDownloadListOpen?"show-file-download-progress":"hide-file-download-progress"}>
            <Col sm={11} xs={10}>
              {downloadFilesList}
            </Col>
            <Col sm={1} xs={2}>
              <Tooltip title="Hide" placement="top"><span className='material-icons' onClick={this.props.hideDownloadList.bind(this)}>close</span></Tooltip>
            </Col>

          </Row>

        </div>
      );
    }

  }
}


const mapStateToProps = (state) => {
  return{
    downloadingList: state.reconReducer.downloadingList,
    isDownloadListOpen:state.reconReducer.isDownloadListOpen
  };
};


export const mapDispatchToProps = (dispatch) => {
  return {
    hideDownloadList : () => {
      dispatch(hideDownloadList());
    },
    clearCommonData:()=>{
      dispatch(clearCommonData());
    }
  }
}


export default connect(mapStateToProps,mapDispatchToProps) (Responsive(SecuredLayout));
